import { render } from "./Spinner.vue?vue&type=template&id=79ac733c&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=79ac733c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79ac733c"

export default script